var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EAF5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.174 10.588a2.05 2.05 0 0 0-.636-1.477 2.225 2.225 0 0 0-1.539-.611H10c-.577 0-1.13.22-1.538.611a2.05 2.05 0 0 0-.637 1.477v11.52c0 .554.23 1.085.637 1.477.408.39.961.611 1.538.611h12c.577 0 1.13-.22 1.539-.611a2.05 2.05 0 0 0 .636-1.477v-11.52Zm-.734 0v11.52c-.046.692-.346.82-.699 1.103-.251.174-.523.204-.742.204H10c-.794 0-1.083-.456-1.238-.604-.154-.149-.17-.493-.17-.703v-11.52c0-.409.46-.79.614-.938.407-.39.884-.325 1.103-.325h11.691c.441 0 .838.177.993.325.154.148.448.53.448.938Z",
    fill: "#6798FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.77 18.41v-5.185c0-.323-.236-.584-.53-.584-.294 0-.53.261-.53.584v5.186c0 .322.236.583.53.583.294 0 .53-.261.53-.583Z",
    fill: "#6798FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.24 12.793-.744.76a.49.49 0 0 1-.7 0 .51.51 0 0 1 0-.71l1.094-1.114a.49.49 0 0 1 .7 0l1.095 1.115a.51.51 0 0 1 0 .709.49.49 0 0 1-.7 0l-.745-.76ZM19.064 18.314v-6.051c0-.376-.235-.68-.529-.68-.294 0-.53.304-.53.68v6.05c0 .376.236.681.53.681.294 0 .53-.305.53-.68Z",
    fill: "#6798FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.535 12.793-.744.76a.49.49 0 0 1-.7 0 .51.51 0 0 1 0-.71l1.094-1.114a.49.49 0 0 1 .7 0l1.094 1.115a.51.51 0 0 1 0 .709.49.49 0 0 1-.7 0l-.744-.76ZM11.904 21.112h8.19c.37 0 .67-.237.67-.53 0-.292-.3-.53-.67-.53h-8.19c-.37 0-.67.238-.67.53 0 .293.3.53.67.53Z",
    fill: "#6798FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.bb12a85181e0d56d498ec59a957ad90d.svg";
export { ForwardRef as ReactComponent };